'use strict'

let issueTypes={
  change: "Endringsanmodning",
  specification: "Avvik fra spesifikasjon",
  problem: "Problem / bekymring"
};

let impact="Konsekvens";
let options="Alternativer";
let recommendation="Anbefaling";
let decision="Beslutning";

export let norwegian={
  general: {
    approach: "tilnærming",
    examineDetails: {
      description: "Beskrivelse",
      typeValues: issueTypes
    },
    proposeDetails: {
      impact: impact
    },
    decideDetails: {
      options: options,
      recommendation: recommendation
    },
    implementDetails: {
      decision: decision
    },
    title: "Endring",
    priority: "Prioritet",
    severity: "Alvorlighet",
    addIssue: "Ny sak",
    noIssues: "Ingen saker i registeret",
    documentIssue: "Trykk \"Ny sak\" hvis du har en endringsordre, avvik-fra-sepsifikasjonen eller problem/bekymring som må dokumenteres.",
    status: {
      captured: "Registrert",
      examined:"Analyserer konsekvens",
      proposed: "Vurderer alternativer",
      decided: "Avventer beslutning",
      implemented: "Følges opp"
    },
  },
  report: {
    cancel: "Avbryt",
    publishReport: "Publiser rapport",
    publishInProgress: "... publisering pågår ...",
    lastIssueReports: "Siste rapporter",
    columns: {
      id: "Id",
      title:"Tittel",
      impact: impact,
      recommendation: "Anbefaling",
      decision: decision,
      status: "Status"
    },
    menu: {
      issueOptions: "Saksvalg",
      createIssueReport: "Opprett saksrapport",
      createExceptionReport: "Opprett unntaksrapport",
      issueReports: "Rapporter",
      noReports: "Ingen rapporter er tilgjengelig",
      whenToUseReports: "Når brukes rapporter: ",
      whenToUseReportsIngress: " Bruk en rapport når det skjer noe uplanlagt og det er behov for å informere prosjektstyret",
      whenToUseIssueReport: "Bruk en saksrapport når du skal holde prosjektstyret informert eller når du ønsker råd fra prosjektstyret.",
      whenToUseExceptionReport: "Bruk unntaktsrapport hvis du trenger en formell beslutning fra prosjektstyret."
    }
  },
  issue: "Sak",
  Capture: {
    title: "Fange opp",
    fields: {
      title: {
        title: "Tittel",
        description:"Beskrivende sakstittle",
        help:"Kort oppsummering av saken"
      },
      type: {
        title: "Sakstype",
        help:`Hvilken type sak er tatt opp?

Forespørsel om endring:
Forslag om endring til grunnlinje
Nye krav, tilføyet omfang etc.

Avvik fra spesifikasjon:
Noe leveres ikke i henhold til avtalt spesifikasjonen
Noe er ikke gjennomgått og godkjent som avtalt

Problem / bekymring:
Annet problem som må løses eller eskaleres`,

        options: issueTypes
      },
      description: {
        title: "Beskrivelse",
        description:"Bakgrunn og årsak til saken",
        help:"Hva er sammenhengen, bakgrunnen, eller utløsende årsak til saken?",
      }
    }
  },
  Examine: {
    title: "Undersøke",
    fields:{
      impact: {
        title: impact,
        description:"Beskriv effekten på mål, begrunnelse og risiko",
        help:`Hvilken innvirkning har saken på:

Tid, kostnad, kvalitet og omfang
begrunnelse og gevinster
Andre avhengige leveranser
Risikoprofil`
      },
      severity: {
        title: "Alvorlighet",
        help:`Hvilken påvirkning er det på målene?

Alvorlig: Kritiske mål vil ikke bli oppnådd
Vesentlig: Angitte mål vil falle under akseptabelt nivå
Moderat: Angitte mål vil falle under målsetningen, men over minimum akseptablt nivå
Mindre: Angitte mål vil falle under målsetningen, men godt over minimum akseptable nivå
Ubetydelig: Ingen eller liten innvirkning på å oppnå mål`,
        options: {
          1: "Ubetydelig",
          2: "Liten",
          3: "Moderat",
          4: "Betydelig",
          5: "Alvorlig"
        }
      },
      priority: {
        title: "Prioritet",
        help:"Hvor mye haster det for å få denne saken løst?",
        options: {
          1: "Veldig lav",
          2: "Lav",
          3: "Middels",
          4: "Høy",
          5: "Veldig høy"
        }
      }
    }
  },
  Propose: {
    title: "Foreslå",
    fields: {
      options: {
        title: options,
        description:"List opp alternativene som er identifisert",
        help:"Hvilke alternativer har blitt vurdert? Har påvirkningen av hvert alternativ blitt vurdert i forhold til tid, kostnad, kvalitet, omfang, gevinst og risiko?",
      },
      recommendation: {
        title: recommendation,
        description:"Beskriv den foreslåtte korrigerende handlingen og hvorfor dette er anbefaling",
        help:"Hvilket alternativ har den beste balansen mellom fordel og tid / kostnad / risiko for implementering?",
      },
      lessonSummary: {
        title: "Erfaringer (vil bare vises i unntaksrapport, ikke i saksrapport)",
        description: "Oppsummer erfaringene som er lært.",
        help: "Hva har vi lært av denne saken? Kunne vi ha unngått eller begrenset denne saken? Kunne vi ha håndtert saken på en bedre måte?"
      }
    }
  },
  Decide: {
    title: "Beslutte",
    fields: {
      decision: {
        title: decision,
        description:"Beskriv hva som ble bestemt, hvor, hvordan, når ..",
        help:"Hva ble det bestemt? Hvor og når ble det bestemt? I et møte, via e-post?",
      },
      decidedBy: {
        title: "Beslutningen er fattet av",
        description:"Navnet på den endelige beslutningstakeren",
        help:"Hvem tok den endelige avgjørelsen? Når? Noen andre konsultert eller inkludert?"
      }
    }
  },
  Implement: {
    title: "Ivertsette",
    fields: {
      status: {
        title: "Status",
        options: {
          Active: "Aktiv",
          Closed: "Lukket"
        }
      },
      statusDescription: {
        title: "Beskrivelse av gjeldende status"
      }
    }
  },
  issueRegister: {
    title: "Saksregister",
    description: "Saksregisteret blir brukt for å dokumentere og vedlikeholde informasjon om alle saker som må formelt behandles. Alle endringsønsker, feil-leveranser og problemer hvor en formell beslutningsprosess er nødvendig, skal dokumenteres som en sak. ",
    description2: "Legg til en ny sak ved å velge 'Ny sak' nedenfor. Du kan vedlikeholde en sak ved å velge den i tabellen nedenfor."
  },
  changeControlApproach: {
    title: "Tilnærming til endringskontroll",
    description: "Tilnærming til endringskontroll beskriver hvordan endringer og situasjoner som oppstår (saker) skal håndteres.",
    fields: {
      process: {
        title: "Prosess og prosedyre",
        help: `Hvordan vil problemer eller endringsforespørsler bli identifisert, anbefalinger utviklet og beslutninger tatt? For små endret, for store endringer?
          Er det noen standard prosedyrer som skal følges for å sikre kontroll på endringer og oppfølging av saker?
          Finnes det planlagt avvik fra disse prosedyrene? Hvis ja, hvorfor?
          Hvordan vil vi sørge for at prosedyren følges - at godkjenningene spores?
          Vil det bli brukt standarder eller maler?
          Hvordan vil endringsprosessen fungere med tredje part?`,
        description: "Beskriv hvilke prosesser som skal følges for å sikre at alle endringer og utfordringer/bekymringer styres godt"
      },
      tools: {
        title: "Verktøy og teknikker",
        help: ` Hvilke teknikker og verktøy vil bli brukt til å identifisere, strukturere og håndtere problemer og endringer?
          Hvilke teknikker og verktøy vil bli brukt til å kontrollere versjonering av dokumenter, kode, tegninger, krav, markedsføringsmateriale, brukerveiledning, opplæringsmateriell, planer, lagplaner etc.?
          Vil et register over saker bli brukt? Hvis ja, er det det eneste verktøyet som brukes til å spore endringshandlinger og godkjenninger? Hvis nei, hva vil det bli brukt i stedet for eller i tillegg?
          Hvilke verktøy eller teknikker brukes av tredjeparter involvert?`,
        description: "Beskriv hvilke verktøy eller teknikker prosjektet skal bruke for å sikre at alle endringer og utfordringer/bekymringer identifiseres, vurderes, løsninger foreslås og beslutninger fattes"
      },
      reporting: {
        title: "Rapportering",
        help: `Når skal det rapporteres om saker / endringer?
          Hvor skal det rapporteres om saker / endringer og hvem vil motta disse rapportene?`,
        description: "Hvilke saksrapporter skal bli produsert, deres formål, timing og mottakere"
      },
      timing: {
        title: "Tidsangivelse av aktiviteter",
        help: `Når vil det bli utført aktivteter for endringskontroll og problemløsingsaktiviteter?
          Vil det utføres spesifikke aktiviteter i Initieringsetappen eller begynnelsen / slutten av etapper?`,
        description: "Beskriv tidspunktet aktiviteter for endringskontroll og problemstillinger skal utføres"
      },
      roles: {
        title: "Roler og ansvar",
        help: `Hvem er ansvarlig for endringskontrollen og utstedelsesprosedyren? Hvem sørger for at prosjektet følger rutinene?
          Hvem godkjenner hvilke typer endringer?
          Hvem skal rapportere saker og endringer og til hvem?`,
        description: "Definer roller og ansvar for aktivitetene"
      },
      scales: {
        title: "Beslutningsmyndighet for alvorlighetsgrad og prioritet",
        help: `Hvem kan ta beslutninger på nivå av saker for alvorlighet og prioritet?
          Skal program-, prosjekt- eller teamlederen ha noen endringsmyndighet på noen av disse nivåene?`,
        description: "Definer hvem som kan ta beslutninger på de ulike nivåene av alvorlighet og prioritet"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/change/labels/norwegian.js